import React from 'react';
import { withRouter } from 'react-router-dom';
import GridMov from './GridMov.jsx';

class MovimentacoesCentro extends React.Component {

    constructor() {

        super();

        this.state = {
            movimentacoes: [],
            centroId: 0,
            centro: "",
            anos: [],
            ano: "Ano",
            mes: "Mês",
            statusCB: true,
            contaCB: true,
            codigoCB: true,
            bancoCB: true,
            dataCB: true,
            historicoCB: true,
            descricaoCB: true,
            valorCB: true,
            saldoCB: true,
            ghgCB: true,
            cadastradoPorCB: true,
            corrigidoPorCB: true
        };

        this.changeAno = this.changeAno.bind(this);
        this.changeMes = this.changeMes.bind(this);
        this.voltar = this.voltar.bind(this);
        this.cadastrar = this.cadastrar.bind(this);
        this.changeStatusCB = this.changeStatusCB.bind(this);
        this.changeContaCB = this.changeContaCB.bind(this);
        this.changeCodigoCB = this.changeCodigoCB.bind(this);
        this.changeBancoCB = this.changeBancoCB.bind(this);
        this.changeDataCB = this.changeDataCB.bind(this);
        this.changeHistoricoCB = this.changeHistoricoCB.bind(this);
        this.changeDescricaoCB = this.changeDescricaoCB.bind(this);
        this.changeValorCB = this.changeValorCB.bind(this);
        this.changeSaldoCB = this.changeSaldoCB.bind(this);
        this.changeGhgCB = this.changeGhgCB.bind(this);
        this.changeCadastradoPorCB = this.changeCadastradoPorCB.bind(this);
        this.changeCorrigidoPorCB = this.changeCorrigidoPorCB.bind(this);

    }

    changeAno(e) {

        let ano = e.target.value;
        this.setState({ ano: ano });

        if (ano === "Ano") {

            this.setState({ pageNum: 1 });
            this.setState({ movimentacoes: [] });

        } else if (ano !== "Ano" && this.state.mes !== "Mês") {

            this.setState({ pageNum: 1 });
            this.setState({ movimentacoes: [] });

            fetch("/api/movimentacao/grid/" + this.state.centroId + "/" + ano + "/" + this.state.mes, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response => response.json())
            .then(responseJson => {

                let mov = responseJson.sort(function(a, b) {

                    let da;
                    let db;

                    if (a.err_data !== 1 && a.err_data !== 2 && a.err_data !== 4) {
                        let dataA = a.data.split("/");
                        da = new Date(dataA[2], dataA[1], dataA[0]);
                    } else {
                        let dataA = a.corr_data.split("/");
                        da = new Date(dataA[2], dataA[1], dataA[0]);
                    }

                    if (b.err_data !== 1 && b.err_data !== 2 && b.err_data !== 4) {
                        let dataB = b.data.split("/");
                        db = new Date(dataB[2], dataB[1], dataB[0]);
                    } else {
                        let dataB = b.corr_data.split("/");
                        db = new Date(dataB[2], dataB[1], dataB[0]);
                    }

                    return da - db;

                });

                this.setState({ movimentacoes: mov });

            });

        }

    }

    changeMes(e) {

        let mes = e.target.value;
        this.setState({ mes: mes });

        if (mes === "Mês") {

            this.setState({ pageNum: 1 });
            this.setState({ movimentacoes: [] });

        } else if (mes !== "Mês" && this.state.ano !== "Ano") {

            this.setState({ pageNum: 1 });
            this.setState({ movimentacoes: [] });

            fetch("/api/movimentacao/grid/" + this.state.centroId + "/" + this.state.ano + "/" + mes, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response => response.json())
            .then(responseJson => {

                let mov = responseJson.sort(function(a, b) {

                    let da;
                    let db;

                    if (a.err_data !== 1 && a.err_data !== 2 && a.err_data !== 4) {
                        let dataA = a.data.split("/");
                        da = new Date(dataA[2], dataA[1], dataA[0]);
                    } else {
                        let dataA = a.corr_data.split("/");
                        da = new Date(dataA[2], dataA[1], dataA[0]);
                    }

                    if (b.err_data !== 1 && b.err_data !== 2 && b.err_data !== 4) {
                        let dataB = b.data.split("/");
                        db = new Date(dataB[2], dataB[1], dataB[0]);
                    } else {
                        let dataB = b.corr_data.split("/");
                        db = new Date(dataB[2], dataB[1], dataB[0]);
                    }

                    return da - db;

                });

                this.setState({ movimentacoes: mov });

            });

        }

    }

    voltar() {
        this.props.history.push("/movimentacoes");
    }

    cadastrar() {

        let obj = {
            centroId: this.state.centroId,
            centro: this.state.centro,
            filtroAno: this.state.ano,
            filtroMes: this.state.mes
        };

        this.props.history.push({
            pathname: "/cadastrarmovimentacao",
            state: obj
        });

    }

    changeStatusCB() {
        this.setState({ statusCB: !this.state.statusCB });
    }

    changeContaCB() {
        this.setState({ contaCB: !this.state.contaCB });
    }

    changeCodigoCB() {
        this.setState({ codigoCB: !this.state.codigoCB });
    }

    changeBancoCB() {
        this.setState({ bancoCB: !this.state.bancoCB });
    }

    changeDataCB() {
        this.setState({ dataCB: !this.state.dataCB });
    }

    changeHistoricoCB() {
        this.setState({ historicoCB: !this.state.historicoCB });
    }

    changeDescricaoCB() {
        this.setState({ descricaoCB: !this.state.descricaoCB });
    }

    changeValorCB() {
        this.setState({ valorCB: !this.state.valorCB });
    }

    changeSaldoCB() {
        this.setState({ saldoCB: !this.state.saldoCB });
    }

    changeGhgCB() {
        this.setState({ ghgCB: !this.state.ghgCB });
    }

    changeCadastradoPorCB() {
        this.setState({ cadastradoPorCB: !this.state.cadastradoPorCB });
    }

    changeCorrigidoPorCB() {
        this.setState({ corrigidoPorCB: !this.state.corrigidoPorCB });
    }

    componentDidMount() {

        if (localStorage.roleMovimentacoes === "nenhuma") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/movimentacoes";
        }

        let cId = this.props.location.state.row.id;
        let centroNome = this.props.location.state.row.data[0];
        let filtroAno = this.props.location.state.row.filtroAno;
        let filtroMes = this.props.location.state.row.filtroMes;

        this.setState({ centroId: cId });
        this.setState({ centro: centroNome });

        if (filtroAno !== undefined && filtroAno !== null &&
            filtroAno !== "" && filtroAno !== "Ano") {

            this.setState({ ano: filtroAno });

        }

        if (filtroMes !== undefined && filtroMes !== null &&
            filtroMes !== "" && filtroMes !== "Mês") {

            this.setState({ mes: filtroMes });

        }

        fetch("/api/movimentacao/ano/" + cId, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ anos: responseJson });

            if (filtroAno !== undefined && filtroAno !== null &&
                filtroAno !== "" && filtroAno !== "Ano" &&
                filtroMes !== undefined && filtroMes !== null &&
                filtroMes !== "" && filtroMes !== "Mês") {

                this.setState({ movimentacoes: [] });

                fetch("/api/movimentacao/grid/" + cId + "/" + filtroAno + "/" + filtroMes, {
                    method: "GET",
                    headers: {
                        "Content-type": "application/json",
                        "Authorization": "Basic " + btoa(localStorage.auth)
                    },
                    mode: "cors"
                })
                .then(response => response.json())
                .then(responseJson => {

                    let mov = responseJson.sort(function(a, b) {

                        let da;
                        let db;

                        if (a.err_data !== 1 && a.err_data !== 2 && a.err_data !== 4) {
                            let dataA = a.data.split("/");
                            da = new Date(dataA[2], dataA[1], dataA[0]);
                        } else {
                            let dataA = a.corr_data.split("/");
                            da = new Date(dataA[2], dataA[1], dataA[0]);
                        }

                        if (b.err_data !== 1 && b.err_data !== 2 && b.err_data !== 4) {
                            let dataB = b.data.split("/");
                            db = new Date(dataB[2], dataB[1], dataB[0]);
                        } else {
                            let dataB = b.corr_data.split("/");
                            db = new Date(dataB[2], dataB[1], dataB[0]);
                        }

                        return da - db;

                    });

                    this.setState({ movimentacoes: mov });

                });

            }

        });

    }

    render() {
        return(
            <div>
                <h1 id="movimentacoes-centro-title">Movimentações Financeiras</h1><br />
                <p id="movimentacoes-centro-centro">
                    <b>Centro: </b> { this.state.centro }
                </p><br />
                <form id="movimentacoes-centro-form">
                    <select value={ this.state.ano } onChange={ this.changeAno }>
                        <option value="Ano">Ano</option>
                        { this.state.anos.map((item, i) =>
                            <option key={ i } value={ item }>{ item }</option> ) }
                    </select>
                    <select value={ this.state.mes } onChange={ this.changeMes }>
                        <option value="Mês">Mês</option>
                        <option value="1">Janeiro</option>
                        <option value="2">Fevereiro</option>
                        <option value="3">Março</option>
                        <option value="4">Abril</option>
                        <option value="5">Maio</option>
                        <option value="6">Junho</option>
                        <option value="7">Julho</option>
                        <option value="8">Agosto</option>
                        <option value="9">Setembro</option>
                        <option value="10">Outubro</option>
                        <option value="11">Novembro</option>
                        <option value="12">Dezembro</option>
                    </select>
                    <span>(Informe o ano e o mês das movimentações financeiras)</span>
                    <br />
                </form><br />

                { (this.state.ano !== "Ano" && this.state.mes !== "Mês") && 
                    <GridMov key={ this.state.movimentacoes }
                        data={ this.state.movimentacoes }
                        pageSize={ 10 }
                        gridWidth={ "1850px" }
                        linkTo={ "/visualizarmovimentacao" }
                        filtroAno={ this.state.ano }
                        filtroMes={ this.state.mes }
                        statusCB={ this.state.statusCB }
                        contaCB={ this.state.contaCB }
                        codigoCB={ this.state.codigoCB }
                        bancoCB={ this.state.bancoCB }
                        dataCB={ this.state.dataCB }
                        historicoCB={ this.state.historicoCB }
                        descricaoCB={ this.state.descricaoCB }
                        valorCB={ this.state.valorCB }
                        saldoCB={ this.state.saldoCB }
                        ghgCB={ this.state.ghgCB }
                        cadastradoPorCB={ this.state.cadastradoPorCB }
                        corrigidoPorCB={ this.state.corrigidoPorCB }
                        changeStatusCB={ this.changeStatusCB }
                        changeContaCB={ this.changeContaCB }
                        changeCodigoCB={ this.changeCodigoCB }
                        changeBancoCB={ this.changeBancoCB }
                        changeDataCB={ this.changeDataCB }
                        changeHistoricoCB={ this.changeHistoricoCB }
                        changeDescricaoCB={ this.changeDescricaoCB }
                        changeValorCB={ this.changeValorCB }
                        changeSaldoCB={ this.changeSaldoCB }
                        changeGhgCB={ this.changeGhgCB }
                        changeCadastradoPorCB={ this.changeCadastradoPorCB }
                        changeCorrigidoPorCB={ this.changeCorrigidoPorCB } /> } 

                <button id="movimentacoes-centro-voltar-btn" onClick={ this.voltar }>
                    Voltar
                </button>
                { (localStorage.roleMovimentacoes === "escrever"
                    || localStorage.roleMovimentacoes === "corrigir") &&
                    <button id="movimentacoes-centro-cadastrar-btn" onClick={ this.cadastrar }>
                        Cadastrar Movimentação Financeira
                    </button> }
                <br /><br />
            </div>
        );
    }

}

export default withRouter(MovimentacoesCentro);

